@if (d) {
    <qp-table-data
        [nullValues]="nullValues"
        [data]="
        [

    ]">
    </qp-table-data>
}